export default "/images/db6aa6a05efcd4a6aa607f040eeee532.avif";